<template>
    <div class="loading-screen">
        <img src="@/assets/logo.svg" alt="לוגו הדרך אל הלב" class="logo">
        <h3>הדרך אל הלב</h3>
        <div class="loading-text">
            <span>{{ loadingText }}</span>
        </div>
    </div>
</template>
  
<script>
import { onMounted, ref } from 'vue'
export default {
    setup() {
        const loadingText = ref('אנא המתן')

        onMounted(() => {
            setInterval(() => {
                loadingText.value = loadingText.value === 'אנא המתן...' ? 'אנא המתן' : loadingText.value + '.'
            }, 500)
        })

        return {
            loadingText,
        }
    }
}
</script>
  
<style scoped>
.loading-screen {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: transparent;
}

.loading-text {
    font-size: 16px;
    margin-top: 60px;
    margin-right: 40px;
}

.loading-text span {
    direction: rtl;
    display: inline-block;
    width: 100px;
    text-align: right;
    white-space: nowrap;
    overflow: hidden;
}

.logo {
    width: 150px;
    height: 150px;
    animation: rotateY 5s linear infinite;
}

@keyframes rotateY {
    0% {
        transform: rotateY(0deg);
    }

    100% {
        transform: rotateY(360deg);
    }
}
</style>
  